<template>
  <div></div>
</template>

<script>
export default {
  name: "LoveWayCareerIndex",

  data() {
    return {};
  },

  mounted() {
    this.$store.dispatch("user/logout");
    sessionStorage.removeItem("setTenantId");
    sessionStorage.removeItem("studentInfo");
    // this.$router.push("/Login");
  },

  methods: {},
};
</script>

<style lang="less" scoped>
</style>